import HttpFactory from "~/repository/factory";
import type { SchoolStore, StoreConnection } from "~/types/schoolStore";

export default class AdminSchoolStoresModule extends HttpFactory {
  getStore(organizationId: number) {
    return this.get<SchoolStore>(
      `/api/admin/commerce/stores/${organizationId}/`,
    );
  }

  updateRelease(organizationId: number, enabled: boolean, reason: string) {
    return this.patch<SchoolStore>(
      `/api/admin/commerce/stores/${organizationId}/`,
      { enabled, reason },
    );
  }

  approveConnection(
    organizationId: number,
    evidence: Record<string, unknown>,
    approved: boolean,
    reason: string,
  ) {
    return this.post<StoreConnection>(
      `/api/admin/commerce/stores/${organizationId}/connection/homologation/`,
      { evidence, approved, reason },
    );
  }
}
